import { useContext } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import NoFilter from "../../../../DataTable/datatable.nofilter";
import { LotDetailContext } from "../../../../Contexts/LotDetailContext";

export function LRLColumn() {
    const {
        lotFlags: {
            showSpecsWithReleaseLimits
        }
    } = useContext(LotDetailContext);

    return {
        Header: 'LRL',
        accessor: 'lowerReleaseLimit',
        Filter: NoFilter,
        Cell: ({ row, value }: any) => {
            if (value === null) {
                return showSpecsWithReleaseLimits ? <span>{row.original.min}</span> : <></>;
            }

            if (showSpecsWithReleaseLimits) {
                return (
                    <OverlayTrigger overlay={<Tooltip>Sales limit: {row.original.min}</Tooltip>}>
                        <span>{value}</span>
                    </OverlayTrigger>
                );

            }

            return <span>{value}</span>;
        }
    };
}